<template>
  <div class="app" :class="{'isMobile':isMobileDevice && !canRotate, 'deviceRotate':rotateScreen,'expand':tooSmall}">
    <Header/>
    <div class="app-content" :class="{'infoOpened':infoOpened}" >
      <router-view v-if="!isMobileDevice || (canRotate && isMobileDevice) ||  legalPage"/>
      <Loader v-if="!isMobileDevice || (canRotate && isMobileDevice)"/>
      <open-info/>
      <div v-if="tooSmall" class="mobile">
        <div class="mobile-text">
          <p v-if="language == 'en'">Build on Volkswagen is not optimized for small screens.<br> Expand your window to use the configurator.</p>
          <p v-if="language == 'de'">Build on Volkswagen ist nicht für kleine Bildschirme optimiert. Vergrößern Sie Ihr Fenster, um den Konfigurator zu verwenden.</p>
        </div>
      </div>
      <div v-if="!canRotate && isMobileDevice && !legalPage" class="mobile">
        <div  class="mobile-text">
          <p v-if="language == 'en'">Build on Volkswagen is not available yet on mobile.<br> Please visit us again on a tablet or desktop device.</p>
          <p v-if="language == 'de'">Build on Volkswagen ist mobil leider noch nicht verfügbar.<br> Bitte besuchen Sie uns wieder mit einem Tablet oder Desktop-Gerät.</p>
        </div>
      </div>
      <div v-if="rotateScreen && isMobileDevice && !legalPage" class="window-resize-alert">
        <div class="window-resize-alert-text">

            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="67.27px"
            	 height="72.96px" viewBox="0 0 67.27 72.96" style="enable-background:new 0 0 67.27 72.96;" xml:space="preserve">
            <path d="M8.49,25.74c-0.78,0.78-0.78,2.05,0,2.83l33.94,33.94c0.78,0.78,2.05,0.78,2.83,0l15.56-15.56c0.78-0.78,0.78-2.05,0-2.83
            	L26.88,10.18c-0.78-0.78-2.05-0.78-2.83,0L8.49,25.74z M39,4.06c0.01-0.38,0.24-0.74,0.62-0.89l7.53-3.09
            	c0.51-0.21,1.1,0.03,1.3,0.55c0.21,0.51-0.03,1.1-0.55,1.3l-4.69,1.92c12.28,3.36,21.59,13.43,24.02,25.92
            	c0.11,0.54-0.25,1.07-0.79,1.17c-0.54,0.11-1.07-0.25-1.17-0.79C62.82,17.45,52.78,7.42,39.83,5.13C39.31,5.04,38.96,4.57,39,4.06
            	L39,4.06z M28.26,68.9c-0.01,0.38-0.24,0.74-0.62,0.89l-7.53,3.09c-0.51,0.21-1.1-0.03-1.3-0.55c-0.21-0.51,0.03-1.1,0.55-1.3
            	l4.69-1.92C11.76,65.74,2.45,55.68,0.02,43.19c-0.11-0.54,0.25-1.07,0.79-1.17c0.54-0.11,1.07,0.25,1.17,0.79
            	c2.47,12.7,12.51,22.73,25.46,25.01C27.96,67.91,28.31,68.39,28.26,68.9L28.26,68.9z M7.08,24.32L22.64,8.77
            	c1.56-1.56,4.09-1.56,5.66,0l33.94,33.94c1.56,1.56,1.56,4.09,0,5.66L46.68,63.92c-1.56,1.56-4.09,1.56-5.66,0L7.08,29.98
            	C5.52,28.42,5.52,25.88,7.08,24.32z"/>
            </svg>

          <p v-if="language == 'en'">Build on Volkswagen is optimized for landscape mode, please rotate your screen to start.</p>
          <p v-if="language == 'de'">Build on Volkswagen ist für Querformat optimiert.<br> Bitte drehen Sie den Bildschirm, um zu starten.</p>

        </div>
      </div>
    </div>
    <About/>
    <Cookies/>
  </div>
</template>

<script>
// @ is an alias to /src
import Menu from '@/components/base/Menu.vue'
import Header from '@/components/base/Header.vue'
import Loader from '@/components/Loader.vue';
import About from '@/components/ProjectInfo.vue';
import OpenInfo from '@/components/base/OpenInfo.vue';
import Cookies from '@/components/base/Cookies.vue';
import Logo from '@/components/base/Logo.vue';

import {masterBus} from '@/main.js';
import { mapGetters } from 'vuex'

export default {
  name: 'Default',
  components: {
    Menu,
    Logo,
    Header,
    About,
    Loader,
    OpenInfo,
    Cookies
  },
  data(){
    return{
      resizeTimeout:null,
      tooSmall:false,
      rotateScreen:false,
      canRotate:false
    }
  },
  computed: {
    ...mapGetters(['infoOpened','isMobileDevice','language']),
    legalPage(){
         return this.$route.path.indexOf('/cookie-policy') > 0 || this.$route.path.indexOf('/imprint') > 0 || this.$route.path.indexOf('/conditions-of-use')>0 || this.$route.path.indexOf('/privacy-policy') > 0
     }
  },
  mounted(){
    if(this.checkMobile()){
      if(($(window).width() >= 850 && $(window).height() >= 850)){
        this.$store.dispatch('setMobileDevice',true);
        if($(window).width() < $(window).height()) this.rotateScreen = true;
        this.canRotate = true;
        if(this.$route.path.indexOf("configurator")>0){
          masterBus.$emit('startLoader');
        }else{
          this.$store.dispatch('setAppReady',true);
          $('.loader').fadeOut(500);
        }
      }
      else if(($(window).width() >= 850 && $(window).height() < 850)){
        this.$store.dispatch('setMobileDevice',true);
        this.rotateScreen = false;
        this.canRotate = true;
        if(this.$route.path.indexOf("configurator")>0){
          masterBus.$emit('startLoader');
        }else{
          this.$store.dispatch('setAppReady',true);
          $('.loader').fadeOut(500);
        }
      }
      else if($(window).width() < 850 && $(window).height()>=850){
        this.$store.dispatch('setMobileDevice',true);
        this.rotateScreen = true;
        this.canRotate = true;
        if(this.$route.path.indexOf("configurator")>0){
          masterBus.$emit('startLoader');
        }else{
          this.$store.dispatch('setAppReady',true);
          $('.loader').fadeOut(500);
        }
      }
      else{
        this.$store.dispatch('setMobileDevice',true);
        this.rotateScreen = false;
        this.canRotate = false;
      }

    }
    else{
      this.checkScreenSize();
      if(this.$route.path.indexOf("configurator")>0){
        masterBus.$emit('startLoader');
      }else{
        this.$store.dispatch('setAppReady',true);
        $('.loader').fadeOut(0);
      }
    }
    window.onresize = ()=>{
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(this.checkScreenSize, 100);
    };
  },
  methods:{
    checkScreenSize(){
      if(this.checkMobile()){
        if(window.orientation == 0 && ($(window).width() >= 850 && $(window).height() >= 850)){
          this.rotateScreen = true;
        }
        else{
          if($(window).width() < 850 && $(window).height() < 850){
            this.canRotate = false;
            this.rotateScreen = false;
          }
          else if($(window).width() < 850 && $(window).height()>=850){
              this.rotateScreen = true;
              this.canRotate = true;
          }
          else{
            this.canRotate = true;
            this.rotateScreen = false;
          }
        }
      }
      else{
        if($(window).width() < 950 || $(window).height()<700 ){
          this.tooSmall = true;
        }
        else{
          this.tooSmall = false;
        }
      }
    },
    switchProjectInfo(){
      if(this.infoOpened){
        this.$store.dispatch('setInfoOpened',false);
      }
    },
    checkMobile(){
      return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    }
  }
}
</script>

<style lang="scss">
@mixin cubic-transition($duration) {
  -webkit-transition: all $duration cubic-bezier(0, 0, 0.2, 1);
  -moz-transition: all $duration cubic-bezier(0, 0, 0.2, 1);
  -ms-transition: all $duration cubic-bezier(0, 0, 0.2, 1);
  -o-transition:all $duration cubic-bezier(0, 0, 0.2, 1);
  transition: all $duration cubic-bezier(0, 0, 0.2, 1);
}

.mobile,.window-resize-alert{
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: white;
  text-align: center;
  z-index: 999999;
  &-text{
    position: absolute;
    top: 0;
    left:0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 85%;
    max-width: 600px;
    height: 200px;
    font-size: 1.4rem;
  }
}
.mobile-text{
  display: flex;
  align-items: center;
  justify-content: center;
}
.no-js-container{
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: white;
  text-align: center;
  .text{
    position: absolute;
    top: 0;
    left:0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 90%;
    height: 200px;
    font-size: 1.4rem;
  }
}

.deviceRotate,.expand{
  .app-content{
    max-height: 100vh;
    overflow: hidden;
  }
}
  .app-content{
    min-height: 100vh;
    position: relative;
    z-index: 1;
    background: white;
    transform: translate(0,0);
    @include cubic-transition(.6s);
    &.infoOpened{
      // transform: translate(0,-450px);
      transform: translate(0,-70px);
    }
  }
  @media only screen and (max-width: 700px)  {
    .app-content{
      &.infoOpened{
        // transform: translate(0,-450px);
        transform: translate(0,-150px);
      }
    }
  }

</style>
